import { styled } from '@mui/material/styles';

import { LoanExampleText } from '@/components/LoanExampleText/index.ts';

const BoxContainer = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  width: '40%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  marginTop: theme.spacing(2),
  paddingBottom: theme.spacing(10),
  marginBottom: theme.spacing(4),
  [theme.breakpoints.down('lg')]: {
    width: '80%',
    paddingTop: theme.spacing(3),
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(1),
    width: '100%',
  },
}));

const TextContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  [theme.breakpoints.down('lg')]: {
    width: '70%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '85%',
  },
}));

const Description = styled('div')(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 400,
  fontSize: '1.188rem',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.875rem',
  },
}));

const Disclaimer = () => {
  return (
    <BoxContainer>
      <TextContainer>
        <Description className="typography-v1-body1">
          <LoanExampleText />
        </Description>
      </TextContainer>
    </BoxContainer>
  );
};

export default Disclaimer;
